export default defineAppConfig({
  ui: {
    colors: {
      primary: 'amber',
      neutral: 'slate',
    },
  },
})
